interface AIResponse {
  text: string;
  error?: string;
}

const API_KEY = import.meta.env.VITE_OPENAI_API_KEY || ''; // Placeholder for env variable
const API_URL = 'https://api.openai.com/v1/chat/completions'; // Example using OpenAI

export const aiService = {
  async sendMessage(message: string, context?: string): Promise<AIResponse> {
    try {
      // If no API key is configured, return a mock response for demonstration
      if (!API_KEY) {
        return this.getMockResponse(message);
      }

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            {
              role: 'system',
              content: `You are a helpful support assistant for SoArtistic, a social platform for artists. 
                        Your goal is to help users with questions about their account, password, profile, and app features.
                        Context: ${context || 'User is asking for help.'}`
            },
            {
              role: 'user',
              content: message
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to get response from AI provider');
      }

      const data = await response.json();
      return {
        text: data.choices[0].message.content
      };

    } catch (error) {
      console.error('AI Service Error:', error);
      // Fallback to mock response in case of error
      return this.getMockResponse(message);
    }
  },

  // Mock response generator (fallback)
  getMockResponse(text: string): AIResponse {
    const lowerText = text.toLowerCase();
    
    // Simulating "Immediate relevant responses" based on keywords
    if (lowerText.includes('password') || lowerText.includes('contraseña') || lowerText.includes('clave')) {
      return {
        text: 'Para cambiar o recuperar tu contraseña, ve a la configuración de tu perfil en la sección de Seguridad. Si no puedes acceder, utiliza la opción "¿Olvidaste tu contraseña?" en la pantalla de inicio de sesión.'
      };
    }
    
    if (lowerText.includes('profile') || lowerText.includes('perfil') || lowerText.includes('foto')) {
      return {
        text: 'Puedes editar tu perfil haciendo clic en tu foto de avatar y seleccionando "Editar Perfil". Allí podrás cambiar tu foto, biografía y categorías de arte.'
      };
    }

    if (lowerText.includes('subscription') || lowerText.includes('suscripción') || lowerText.includes('premium')) {
      return {
        text: 'SoArtistic ofrece planes gratuitos y premium. Puedes ver los detalles y actualizar tu plan en Configuración > Suscripción.'
      };
    }

    if (lowerText.includes('upload') || lowerText.includes('subir') || lowerText.includes('publicar')) {
      return {
        text: 'Para subir contenido, pulsa el botón "+" en la barra de navegación inferior. Puedes subir fotos, videos o crear publicaciones de texto.'
      };
    }

    return {
      text: 'Entiendo tu consulta. Como soy un asistente virtual, puedo ayudarte con preguntas frecuentes. Para temas más complejos, por favor contacta a soporte@soartistic.com.'
    };
  }
};
